// Vendor
import '../../vendor/vendor'

// Components
import '../../components/components'

window.addEventListener('load', () => {
	document.querySelector('html').classList.remove('loading')
})
